import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { App, Breadcrumb, Layout, Spin, theme } from 'antd';

import { PageLayout } from '@app/web-components';

import { useFindBundleById } from '../data';
import { CreateForm } from '../forms';

export const CreatePage = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [searchParams] = useSearchParams();
  const { notification } = App.useApp();
  const bundleId = Number(searchParams.get('id') ?? undefined);
  const isCopy = !isNaN(bundleId);

  const { data, error, isPending } = useFindBundleById({ bundleId: bundleId, enabled: isCopy });

  useEffect(() => {
    if (error) {
      notification.open({
        message: 'Copy Bundle Error',
        description: error.message,
        duration: 0,
      });
    }
  });

  return (
    <>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[{ title: <Link to="/">Home</Link> }, { title: <Link to="../">Bundles</Link> }, { title: 'Create' }]}
      />
      <Layout.Content
        style={{
          padding: 24,
          margin: 'auto',
          height: '100%',
          width: '100%',
          maxWidth: 1200,
          minHeight: 0,
          background: colorBgContainer,
          overflow: 'auto',
        }}
      >
        <PageLayout.Title title="Create Bundle" />
        {isCopy && isPending ? <Spin style={{ width: '100%' }} /> : <CreateForm record={data} />}
      </Layout.Content>
    </>
  );
};
